import React, { useState, useEffect } from 'react';
import { isMobile } from '../../../utils/validation';
import './PhoneNumberCaptureBottom.scss';

const PhoneNumberCaptureBottom = props => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errorPhoneNumber, setErrorPhoneNumber] = useState('');
  const [isCountrySingaporeMobile, setIsCountrySingaporeMobile] = useState(false);
  const {
    login,
    hasCookieExpired,
    numberSubmitting,
    numberSubmitted,
    numberSubmitError,
    phoneCaptureData,
    submitMobileNumber,
    countryConfig,
    localeInfo,
    handleClose,
    isRepeat,
    dataLocale: {
      ENTER_NUMBER_TO_UNLOCK_OFFER,
      CONTINUE,
      YOUR_PHONE_NUMBER,
      SYMBOL_ASTRIX,
      WE_WILL_NOT_SHARE_NUMBER_WITH_ANYONE,
      PHONE_CODE,
      OFFER_UNLOCKED,
      SHOP_NOW,
    },
  } = props;
  const { countryCode } = localeInfo;

  useEffect(() => {
    if (!numberSubmitError && numberSubmitted) {
        setIsCountrySingaporeMobile(true);
    } else if (numberSubmitError) {
      setErrorPhoneNumber(numberSubmitError.message);
    }
  }, [numberSubmitted, numberSubmitError]);

  const checkLoginRepeat = () => {
    if (login && !isRepeat) {
      return true;
    } else if (login && isRepeat) {
      return false;
    } else if (!login) {
      return true;
    }
  };

  const postPhoneNumber = () => {
    if (isMobile(phoneNumber, { countryCode })) {
      setErrorPhoneNumber('Please enter a valid Mobile Number');
    } else {
      submitMobileNumber(phoneNumber);
    }
  };

  return (
    <React.Fragment>
      {checkLoginRepeat() && hasCookieExpired && (
        <>
          <div className="overlay">
            <div className="cat-mobile-capture-bottom text-center text-white">
              <div
                className="cat-mobile-capture-close text-right fsp16 mr-r15 text-white"
                onClick={handleClose}
              >
                &#10005;
              </div>
              <div className="cat-mobile-capture-text fw-700 fsp16 text-uppercase mr-t10 pd-l30 pd-r30">
                {!isCountrySingaporeMobile
                  ? phoneCaptureData.headerText || ENTER_NUMBER_TO_UNLOCK_OFFER
                  : OFFER_UNLOCKED}
              </div>

              {isCountrySingaporeMobile && (
                <div className="cat-mobile-capture-text fw-700 fsp16 text-uppercase mr-t10 pd-l30 pd-r30">
                  {`Use Code ${phoneCaptureData?.leadCouponCode}`}
                </div>
              )}

              <div className="capture-phone">
                {!isCountrySingaporeMobile && (
                  <div className="phnnumberWrapper mr-t30 mr-b10">
                    {countryConfig.availableCountries &&
                    countryConfig.availableCountries.length > 0 ? (
                      <select
                        className="uae-width country-code inline-block pos-abs fsp20 country-code-m-display text-cool_grey"
                        name="countryCodes"
                      >
                        {countryConfig.availableCountries?.map(cc => (
                          <option value={cc.code}>{cc.code}</option>
                        ))}
                      </select>
                    ) : (
                      <div className="country-code">{PHONE_CODE}</div>
                    )}
                    <div>
                      <div className="hor-separator"></div>
                      <input
                        autoComplete="phone"
                        className={`${countryCode}-input-padding no-padding-left input-signup-mobile`}
                        maxLength={localeInfo.maxMobileNumberLength}
                        minLength={localeInfo.minMobileNumberLength}
                        name="phone"
                        placeholder={
                          `${phoneCaptureData.inputLabel} ${SYMBOL_ASTRIX}` ||
                          `${YOUR_PHONE_NUMBER} ${SYMBOL_ASTRIX}`
                        }
                        type="tel"
                        value={phoneNumber}
                        onChange={e => {
                          setPhoneNumber(e.target.value);
                          setErrorPhoneNumber('');
                        }}
                      />
                    </div>
                  </div>
                )}
                {errorPhoneNumber && !isCountrySingaporeMobile && (
                  <div className="text-color_brick_red text-error">{errorPhoneNumber}</div>
                )}

                {!isCountrySingaporeMobile && (
                  <button
                    className="btn-phone-capture new-btn bg-topaz fsp16 text-color_white"
                    type="submit"
                    onClick={postPhoneNumber}
                  >
                    {numberSubmitting ? (
                      <span className="pd-t5 pd-b5 block icon-spinner animate-spin"></span>
                    ) : (
                      <span className="pd-t5 pd-b5 block">
                        {phoneCaptureData.buttonTxt || CONTINUE}
                      </span>
                    )}
                  </button>
                )}
              </div>

              {isCountrySingaporeMobile && (
                <a href={phoneCaptureData?.redirectionUrl} onClick={handleClose} className="block">
                  <button className="btn-phone-capture new-btn bg-topaz fsp16 text-color_white pd-y-5">
                    {SHOP_NOW}
                  </button>
                </a>
              )}

              <p className="fsp10 text-white text-extra-bold">
                {phoneCaptureData.subHeadingText || WE_WILL_NOT_SHARE_NUMBER_WITH_ANYONE}
              </p>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default PhoneNumberCaptureBottom;
